// Google Analytics Composable
import { onMounted } from 'vue'

export function useGoogleAnalytics(trackingId) {
  const initGA = () => {
    // Google Analytics 4 is already loaded from HTML head
    // Just configure additional settings if needed
    if (typeof gtag !== 'undefined') {
      gtag('config', trackingId, {
        page_title: document.title,
        page_location: window.location.href,
        custom_map: {
          'custom_parameter_1': 'performance_status'
        }
      })
    }
  }

  const trackEvent = (eventName, parameters = {}) => {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, parameters)
    }
  }

  const trackPageView = (pageTitle, pagePath) => {
    if (typeof gtag !== 'undefined') {
      gtag('config', trackingId, {
        page_title: pageTitle,
        page_location: window.location.origin + pagePath
      })
    }
  }

  const trackUserInteraction = (action, category = 'engagement') => {
    trackEvent(action, {
      event_category: category,
      event_label: window.location.pathname
    })
  }

  // Scroll tracking for engagement
  const trackScrollDepth = () => {
    let maxScroll = 0
    const checkScrollDepth = () => {
      const scrollPercent = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      )
      
      if (scrollPercent > maxScroll && scrollPercent % 25 === 0 && scrollPercent <= 100) {
        maxScroll = scrollPercent
        trackEvent('scroll_depth', {
          event_category: 'engagement',
          event_label: `${scrollPercent}%`,
          value: scrollPercent
        })
      }
    }

    window.addEventListener('scroll', checkScrollDepth, { passive: true })
    return () => window.removeEventListener('scroll', checkScrollDepth)
  }

  onMounted(() => {
    initGA()
  })

  return {
    trackEvent,
    trackPageView,
    trackUserInteraction,
    trackScrollDepth
  }
}